import {ViewerEnd} from '../../../../../../graphql/generated/types';
import {createQueryClient} from '../../../../../../reactQuery/createQueryClient';
import {useViewerEndQuery} from '../../../../../../wrapper/viewerWrapper';

export function updateCacheSubtractRating({
  seriesId,
  productId,
  myRating,
}: {
  seriesId: number;
  productId: number;
  myRating: number;
}) {
  const queryClient = createQueryClient();
  queryClient.setQueryData(
    useViewerEndQuery.getKey({seriesId, productId}),
    (prevData: ViewerEnd | undefined) => {
      if (!prevData) {
        return prevData;
      }
      return {
        ...prevData,
        ratingCount: prevData.ratingCount - 1,
        ratingSum: prevData.ratingSum - myRating || 0,
      };
    }
  );
}
